
import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.PaymentTypesRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about users
 * using http requests.
 */
export default class PaymentTypesRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.PaymentTypesRestService#getAllAsync
     * @methodOf rest.services.PaymentTypesRestService
     * @function
     *
     * @description
     * Retrieves the user payment types
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync('payment-types/');

    }

}

_serviceDependencies.push(PaymentTypesRestService);

angular.module('rest.services')
    .service('PaymentTypesRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/paymentTypesRestService.js